import type { GlobalClassVSGeneral } from '../../domain/entities/global-class-vs-general.entity';
import type { GlobalStudentRanking } from '../../domain/entities/global-student-ranking.entity';
import type { GlobalStudentVSGeneral } from '../../domain/entities/global-student-vs-general.entity';
import type { GlobalDashboardApiDatasource } from '../datasources/global-dashboard-api.datasource';

export class GlobalDashboardRepositoryImpl {
  private readonly api: GlobalDashboardApiDatasource;

  constructor(api: GlobalDashboardApiDatasource) {
    this.api = api;
  }

  async getGlobalStudentRanking(
    page: number,
    pageSize: number,
  ): Promise<GlobalStudentRanking> {
    return this.api.getGlobalStudentRanking(page, pageSize);
  }

  async getClassVSGeneral(
    institution?: string,
    courseId?: string,
  ): Promise<GlobalClassVSGeneral> {
    return this.api.getClassVSGeneral(institution, courseId);
  }

  async getStudentVSGeneral(email: string): Promise<GlobalStudentVSGeneral> {
    return this.api.getStudentVSGeneral(email);
  }
}
